import script from "./Service.vue?vue&type=script&setup=true&lang=js"
export * from "./Service.vue?vue&type=script&setup=true&lang=js"

import "./Service.vue?vue&type=style&index=0&id=6e6b4c98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e6b4c98"]])

export default __exports__